import { getCookie, setCookie } from "../cookies/cookies";

export const SELECTED_REGION_COOKIE_NAME = "delivery_region_code";

export const getRegionIdCookie = (): string | null => {
  try {
    const value = getCookie(SELECTED_REGION_COOKIE_NAME);
    return typeof value === "string" ? value : null;
  } catch {
    return null;
  }
};

export const hasRegionIdCookie = (): boolean => {
  return Boolean(getRegionIdCookie());
};

const getRegionIdFallbackStorageValue = (): string | null => {
  try {
    const regionId = sessionStorage.getItem(SELECTED_REGION_COOKIE_NAME);
    if (regionId) {
      return regionId;
    }
  } catch {
    // ignore
  }

  try {
    const regionId = localStorage.getItem(SELECTED_REGION_COOKIE_NAME);
    if (regionId) {
      return regionId;
    }
  } catch {
    // ignore
  }

  return null;
};

export const setRegionIdFallbackStorage = (regionId: string) => {
  try {
    sessionStorage.setItem(SELECTED_REGION_COOKIE_NAME, regionId);
  } catch {
    // ignore
  }

  try {
    localStorage.setItem(SELECTED_REGION_COOKIE_NAME, regionId);
  } catch {
    // ignore
  }
};

export const getSelectedRegionId = (): string | null => {
  return getRegionIdCookie() || getRegionIdFallbackStorageValue();
};

export const isRegionIdConfirmed = (): boolean => {
  return Boolean(getSelectedRegionId());
};

export const setRegionIdCookie = (regionId: string) => {
  setCookie(SELECTED_REGION_COOKIE_NAME, regionId, "/", undefined, { sameSite: "None", secure: true });

  if (!hasRegionIdCookie()) {
    setRegionIdFallbackStorage(regionId);
  }
};
